// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class CtsGantryCacheModel<T> {
  private readonly cache = new Map<string, T>();

  public cacheData(eventSource: string, data: T): void {
    if (eventSource) {
      this.cache.set(eventSource, data);
    }
  }

  public hasData(eventSource: string): boolean {
    return this.cache.has(eventSource);
  }

  public getCachedData(eventSource: string): T | undefined {
    return this.cache.get(eventSource);
  }
}
